module.exports = __webpack_public_path__ + "static/media/parse_logo_light_red.a663175e.png";